<template>
  <div>
    <div
      class="text-white flex items-center justify-between cursor-pointer lg:p-0"
      data-testid="locationDisplay"
      @click="$overlay.open('locationModal')"
    >
      <div class="flex items-center">
        <LocationIcon class="w-4 h-4 mr-1 fill-current" aria-label="Location icon" />
        <span>{{ formattedLocation }}</span>
      </div>
      <div class="block text-gray-lighter lg:hidden">
        <span>Change</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LocationIcon from '@/assets/location.svg?component'

const { formattedLocation } = useLocation()
</script>
